// Portfolio Section Data
import { SectionHeader } from '../data/schemas';

// Import images
import quizplus from '../assets/quizplus.jpg';
import tafawaq from '../assets/tafawaq.png';
import water from '../assets/water.png';
import emergency from '../assets/p1.jpg';
import ajjawe from '../assets/ajjawe.png';
import jsoor from '../assets/jsoor.png';

export const portfolioData = {
  header: new SectionHeader("My Recent Work", "Portfolio", "portfolio"),
  items: [
    {
      id: 1,
      image: quizplus,
      title: "QuizPlus Mobile App",
      description: "Cross-platform mobile app for students to access millions of questions and solutions.",
      links: {
        website: "https://quizplus.com/",
        playStore: "https://play.google.com/store/apps/details?id=com.quizplus.app&hl=en",
        appStore: "https://apps.apple.com/us/app/quizplus-for-an-a/id1609864371"
      }
    },
    {
      id: 2,
      image: tafawaq,
      title: "Tafawaq App",
      description: "Educational platform enabling students to practice and analyze questions with smart feedback.",
      links: {
        website: "https://tafawaq.sa/",
        playStore: "https://play.google.com/store/apps/details?id=sa.tafawaqsa.app&hl=en",
        appStore: "https://apps.apple.com/us/app/tafawaq-%D8%AA%D9%81%D9%88%D9%82/id6720723334"
      }
    },
    {
      id: 3,
      image: water,
      title: "Water Distribution Management System",
      description: "A smart municipal platform integrated with hardware sensors and AI models to monitor and optimize water distribution automatically based on real-time consumption data.",
      links: {
        github: "https://github.com/rabukhader/Water-Distribution"
      }
    },
    {
      id: 4,
      image: emergency,
      title: "Emergency Call App",
      description: "Mobile app for instant emergency calls and location-based rescue service management.",
      links: {
        github: "https://github.com/rabukhader/Emergency-Call"
      }
    },
    {
      id: 5,
      image: ajjawe,
      title: "Ajjawe Company Website",
      description:
        "Official website for Ajjawi Trading Company—premium food brands and distribution across the Palestinian market. Showcases the company's history, brand portfolio, partner testimonials, customer reviews, and product gallery.",
      links: {
        website: "https://ajjawe.ps/"
      }
    },

    {
      id: 6,
      image: jsoor,
      title: "JSOOR (Graduation Project)",
      description:
        "A crowdfunding platform designed to connect students with business professionals. Integrated with AI, bots, and recommendation systems to provide personalized guidance, project matching, and support for students’ initiatives.",
      links: {}
    }
  ]
};
